import { styled } from '@mui/material';

export const PriceWrapper = styled('span')`
  line-height: 24.8px;
`;

export const Discount = styled(PriceWrapper)`
  text-decoration: line-through;
  margin-right: 6px;
`;
